import {
  GET_EXERCISES,
  GET_EXERCISES_SUCCESS,
  GET_EXERCISES_ERROR,
  CREATE_EXERCISE,
  CREATE_EXERCISE_SUCCESS,
  CREATE_EXERCISE_ERROR,
  UPDATE_EXERCISE,
  UPDATE_EXERCISE_SUCCESS,
  UPDATE_EXERCISE_ERROR,
  DELETE_EXERCISE,
  DELETE_EXERCISE_SUCCESS,
  DELETE_EXERCISE_ERROR,
  RESTORE_EXERCISE,
  RESTORE_EXERCISE_SUCCESS,
  RESTORE_EXERCISE_ERROR,
  GET_ARCHIVED_EXERCISES,
  GET_ARCHIVED_EXERCISES_SUCCESS,
  GET_ARCHIVED_EXERCISES_ERROR,
  HANDLE_CREATE_OR_EDIT_EXERCISE,
  SAVE_EXERCISE_HISTORY,
  SAVE_EXERCISE_HISTORY_SUCCESS,
  SAVE_EXERCISE_HISTORY_ERROR,
  GET_EXERCISE_HISTORY_BY_IDS,
  GET_EXERCISE_HISTORY_BY_IDS_SUCCESS,
  GET_EXERCISE_HISTORY_BY_IDS_ERROR,
  GET_EXERCISES_HISTORY_BY_IDS_ARR,
  GET_EXERCISES_HISTORY_BY_IDS_ARR_SUCCESS,
  GET_EXERCISES_HISTORY_BY_IDS_ARR_ERROR,
  GET_ALL_EXERCISE_HISTORY_BY_IDS_SUCCESS,
  GET_ALL_EXERCISE_HISTORY_BY_IDS_ERROR,
  GET_EXERCISE_CATEGORIES,
  GET_EXERCISE_CATEGORIES_SUCCESS,
  GET_EXERCISE_CATEGORIES_ERROR,
  GET_MUSCLES,
  GET_MUSCLES_SUCCESS,
  GET_MUSCLES_ERROR,
  GET_RECENT_PRS,
  GET_RECENT_PRS_SUCCESS,
  GET_RECENT_PRS_ERROR,
} from './constants';

export function getExercises() {
  return {
    type: GET_EXERCISES,
  };
}

export function getExercisesSuccess(payload) {
  return {
    type: GET_EXERCISES_SUCCESS,
    payload,
  };
}

export function getExercisesError(err) {
  return {
    type: GET_EXERCISES_ERROR,
    err,
  };
}

export function createExercise(exercise) {
  return {
    type: CREATE_EXERCISE,
    exercise,
  };
}

export function createExerciseSuccess(payload) {
  return {
    type: CREATE_EXERCISE_SUCCESS,
    payload,
  };
}

export function createExerciseError(err) {
  return {
    type: CREATE_EXERCISE_ERROR,
    err,
  };
}

export function updateExercise(exercise) {
  return {
    type: UPDATE_EXERCISE,
    exercise,
  };
}

export function updateExerciseSuccess(payload) {
  return {
    type: UPDATE_EXERCISE_SUCCESS,
    payload,
  };
}

export function updateExerciseError(err) {
  return {
    type: UPDATE_EXERCISE_ERROR,
    err,
  };
}

export function deleteExercise(id) {
  return {
    type: DELETE_EXERCISE,
    id,
  };
}

export function deleteExerciseSuccess(payload) {
  return {
    type: DELETE_EXERCISE_SUCCESS,
    payload,
  };
}

export function deleteExerciseError(err) {
  return {
    type: DELETE_EXERCISE_ERROR,
    err,
  };
}

export function restoreExercise(id) {
  return {
    type: RESTORE_EXERCISE,
    id,
  };
}

export function restoreExerciseSuccess(payload) {
  return {
    type: RESTORE_EXERCISE_SUCCESS,
    payload,
  };
}

export function restoreExerciseError(err) {
  return {
    type: RESTORE_EXERCISE_ERROR,
    err,
  };
}

export function getArchivedExercises() {
  return {
    type: GET_ARCHIVED_EXERCISES,
  };
}

export function getArchivedExercisesSuccess(payload) {
  return {
    type: GET_ARCHIVED_EXERCISES_SUCCESS,
    payload,
  };
}

export function getArchivedExercisesError(err) {
  return {
    type: GET_ARCHIVED_EXERCISES_ERROR,
    err,
  };
}

export function handleCreateOrEditExercise(options, value, exercise, field) {
  let editExercise = { ...exercise };

  let exerciseOptions = options && options;

  // Multi-select array fields. antd's `onChange` for `mode='multiple'`
  // always emits the FULL current selection, so we REPLACE the field
  // with the incoming value rather than unioning it with what was
  // there. The previous union-via-Set never let the user deselect
  // anything (removal would shrink `value` but the old IDs stayed
  // around).
  if (
    field === 'primaryMuscles' ||
    field === 'secondaryMuscles' ||
    field === 'equipment' ||
    field === 'variations' ||
    field === 'categories'
  ) {
    const incoming = Array.isArray(value)
      ? value
      : value === undefined || value === null || value === ''
      ? []
      : [value];
    editExercise[field] = incoming
      .map((item) =>
        typeof item === 'object' && item._id ? item._id : item
      )
      .filter(Boolean);
  } else if (field === 'translations.es') {
    // Combined Spanish overlay write — used by AI-suggest, which returns name +
    // instructions together. Merging in one dispatch avoids the clobber that
    // two back-to-back dispatches cause (each rebuilds `translations` from the
    // same stale snapshot, so the second would drop the first's field).
    const prevEs = (editExercise.translations || {}).es || {};
    const incoming = (value && value.target && value.target.value) || {};
    editExercise.translations = {
      ...(editExercise.translations || {}),
      es: { ...prevEs, ...incoming },
    };
  } else if (
    field === 'translations.es.name' ||
    field === 'translations.es.instructions'
  ) {
    // Nested Spanish overlay (platform-admin only). Value is a synthetic
    // input event like the other text fields. Rebuild the nested path
    // immutably so the rest of `translations` (the other es field) survives.
    const sub = field.split('.')[2]; // 'name' | 'instructions'
    const prevEs = (editExercise.translations || {}).es || {};
    editExercise.translations = {
      ...(editExercise.translations || {}),
      es: { ...prevEs, [sub]: value.target.value },
    };
  } else if (
    field === 'difficulty' ||
    field === 'commonName' ||
    field === 'movementPattern' ||
    field === 'primaryEquipment' ||
    field === 'benchAngle' ||
    field === 'trackingType' ||
    field === 'loadType'
  ) {
    // Direct-value string fields. Phase-1 taxonomy fields go through
    // this branch because the AI suggest flow dispatches their raw
    // string values (not synthetic input events). `trackingType` /
    // `loadType` join the same branch so the Exercise edit modal's
    // segmented controls can dispatch 'reps'/'time' and
    // 'external'/'assisted' directly.
    editExercise[field] = value;
  } else {
    editExercise[field] = value.target.value;
  }

  const errors = [];
  if (!editExercise.name) {
    errors.push('Please fill the required field');
  }

  return {
    type: HANDLE_CREATE_OR_EDIT_EXERCISE,
    field,
    editExercise,
    exerciseOptions,
    errors,
  };
}

export function saveExerciseHistory(dataArr, workoutId) {
  return {
    type: SAVE_EXERCISE_HISTORY,
    dataArr,
    workoutId,
  };
}

export function saveExerciseHistorySuccess(payload) {
  return {
    type: SAVE_EXERCISE_HISTORY_SUCCESS,
    payload,
  };
}

export function saveExerciseHistoryError(err) {
  return {
    type: SAVE_EXERCISE_HISTORY_ERROR,
    err,
  };
}

export function getExerciseHistoryByIds(
  clientId,
  exerciseId,
  allHistory,
  callback
) {
  return {
    type: GET_EXERCISE_HISTORY_BY_IDS,
    clientId,
    exerciseId,
    allHistory,
    callback,
  };
}

export function getExerciseHistoryByIdsSuccess(payload) {
  return {
    type: GET_EXERCISE_HISTORY_BY_IDS_SUCCESS,
    payload,
  };
}

export function getExerciseHistoryByIdsError(err) {
  return {
    type: GET_EXERCISE_HISTORY_BY_IDS_ERROR,
    err,
  };
}

export function getAllExerciseHistoryByIdsSuccess(payload, exerciseId) {
  return {
    type: GET_ALL_EXERCISE_HISTORY_BY_IDS_SUCCESS,
    payload,
    exerciseId,
  };
}

export function getAllExerciseHistoryByIdsError(err) {
  return {
    type: GET_ALL_EXERCISE_HISTORY_BY_IDS_ERROR,
    err,
  };
}

export function getExercisesHistoryByIdsArr(clientId, exerciseIdsArr) {
  return {
    type: GET_EXERCISES_HISTORY_BY_IDS_ARR,
    clientId,
    exerciseIdsArr,
  };
}

export function getExercisesHistoryByIdsArrSuccess(payload) {
  return {
    type: GET_EXERCISES_HISTORY_BY_IDS_ARR_SUCCESS,
    payload,
  };
}

export function getExercisesHistoryByIdsArrError(err) {
  return {
    type: GET_EXERCISES_HISTORY_BY_IDS_ARR_ERROR,
    err,
  };
}

export function getExerciseCategories() {
  return {
    type: GET_EXERCISE_CATEGORIES,
  };
}

export function getExerciseCategoriesSuccess(payload) {
  return {
    type: GET_EXERCISE_CATEGORIES_SUCCESS,
    payload,
  };
}

export function getExerciseCategoriesError(err) {
  return {
    type: GET_EXERCISE_CATEGORIES_ERROR,
    err,
  };
}

export function getMuscles() {
  return {
    type: GET_MUSCLES,
  };
}

export function getMusclesSuccess(payload) {
  return {
    type: GET_MUSCLES_SUCCESS,
    payload,
  };
}

export function getMusclesError(err) {
  return {
    type: GET_MUSCLES_ERROR,
    err,
  };
}

export function getRecentPrs(clientId, limit = 8) {
  return {
    type: GET_RECENT_PRS,
    clientId,
    limit,
  };
}

export function getRecentPrsSuccess(payload) {
  return {
    type: GET_RECENT_PRS_SUCCESS,
    payload,
  };
}

export function getRecentPrsError(err) {
  return {
    type: GET_RECENT_PRS_ERROR,
    err,
  };
}

// export function getExerciseHistory(dataObj) {
//   return {
//     type: GET_EXERCISE_HISTORY,
//     dataObj
//   };
// }

// export function getExerciseHistorySuccess(payload) {
//   return {
//     type: GET_EXERCISE_HISTORY_SUCCESS,
//     payload
//   };
// }

// export function getExerciseHistoryError(err) {
//   return {
//     type: GET_EXERCISE_HISTORY_ERROR,
//     err
//   };
// }
